import React from "react";
import "../styles/Footer.css";
import logo from "../assets/images/javelynkslogo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Logo + tagline */}
        <div className="footer__col">
          <img src={logo} alt="Logo" className="footer__logo" />
          <p className="footer__tagline">
            Fast, precise, and adaptive engineering—always on target.
          </p>
        </div>

        {/* Company */}
        <div className="footer__col">
          <h4 className="footer__heading">Company</h4>
          <ul>
            <li>
              <a href="#identity">About</a>
            </li>
            <li>
              <a href="#services">Services</a>
            </li>
            <li>
              <a href="#industries">Industries</a>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer__col">
          <h4 className="footer__heading">Legal</h4>
          <ul>
            <li>
              <a href="#privacy">Privacy</a>
            </li>
            <li>
              <a href="#terms">Terms</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h4 className="footer__heading">Contact</h4>
          <ul>
            <li>
              <a href="mailto:info@javelynx.com">info@javelynx.com</a>
            </li>
            <li>
              <a href="tel:+33771829692">+33 7 71 82 96 92</a>
            </li>
            <li>
              <a href="tel:+96171965968">+961 71 965 968</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="footer__bottom">
        <div className="footer__bottom-text">
          &copy; {new Date().getFullYear()} Javelynx. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
